import { Box, Stack } from '@mui/material';

import { FormikTextField } from '@/common/presentation/components/forms/fields/FormikTextField';
import { HighlightedFields } from '@/map/domain/entities/map.types';
import { LocationFormData } from '../validationSchema';

interface LocationFormFieldsProps {
  highlightedFields?: HighlightedFields;
  handleCoordinatesChange: (field: 'latitude' | 'longitude', value: number) => void;
  hideCoordinates?: boolean;
  hideCountry?: boolean;
}

export const LocationFormFields: React.FC<LocationFormFieldsProps> = ({
  highlightedFields,
  handleCoordinatesChange,
  hideCoordinates = false,
  hideCountry = false
}) => {
  return (
    <Stack spacing={1}>
      <Box>
        <FormikTextField<LocationFormData>
          required
          id="address"
          label="Address"
          size="small"
          highlighted={highlightedFields?.address}
          testId="map:address-input"
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Box sx={{ flex: 1 }}>
          <FormikTextField<LocationFormData>
            required
            id="city"
            label="City"
            size="small"
            highlighted={highlightedFields?.city}
            testId="map:city-input"
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <FormikTextField<LocationFormData>
            required
            id="state"
            label="State"
            size="small"
            highlighted={highlightedFields?.state}
            inputProps={{ maxLength: 3 }}
            testId="map:state-input"
          />
        </Box>
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {!hideCountry && (
          <Box sx={{ flex: 1 }}>
            <FormikTextField<LocationFormData>
              id="country"
              label="Country"
              size="small"
              highlighted={highlightedFields?.country}
              testId="map:country-input"
            />
          </Box>
        )}
        <Box sx={{ flex: 1 }}>
          <FormikTextField<LocationFormData>
            required
            id="zipCode"
            label="ZIP Code"
            size="small"
            highlighted={highlightedFields?.zipCode}
            inputProps={{ maxLength: 10 }}
            testId="map:zip-code-input"
          />
        </Box>
      </Box>
      {!hideCoordinates && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box sx={{ flex: 1 }}>
            <FormikTextField<LocationFormData>
              required
              id="latitude"
              label="Latitude"
              type="number"
              size="small"
              onChange={(e) => {
                const newLat = parseFloat(e.target.value);
                if (!isNaN(newLat)) {
                  handleCoordinatesChange('latitude', newLat);
                }
              }}
              highlighted={highlightedFields?.latitude}
              testId="map:latitude-input"
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <FormikTextField<LocationFormData>
              required
              id="longitude"
              label="Longitude"
              type="number"
              size="small"
              onChange={(e) => {
                const newLng = parseFloat(e.target.value);
                if (!isNaN(newLng)) {
                  handleCoordinatesChange('longitude', newLng);
                }
              }}
              highlighted={highlightedFields?.longitude}
              testId="map:longitude-input"
            />
          </Box>
        </Box>
      )}
    </Stack>
  );
};
